import { LogPagination } from '../../Model/Log';
import { LogRepository, LogParams } from '../Repositories/LogRepository';

export class GetLogsPageUseCase {
  constructor(private repo: LogRepository) {}

  execute(params?: LogParams): Promise<LogPagination> {
    return this.repo
      .getLogsPage(params)
      .then(r => r)
      .catch(err => Promise.reject(err));
  }
}
